export const toJson = <Result = unknown>(
  value: unknown
): Result | undefined => {
  try {
    return typeof value === "string" ? JSON.parse(value) : undefined;
  } catch (error) {
    return undefined;
  }
};
